










































































































































































import { defineComponent, computed, onMounted } from "@vue/composition-api";
import { useConfigStore } from "~/stores/extensionApi";
import { changeImage } from "~/helpers";
import { ref } from "@nuxtjs/composition-api";

export default defineComponent({
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
    systemLog: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const configStore = useConfigStore();
    const configs = computed(() => configStore.getConfigs);
    const dataSize = configs.value.sizeguide_config.find(
      (e) => e.id.toString() === props.id
    )?.data;
    const dataHeader = dataSize?.[0] || "";
    const dataBody = dataSize?.slice(1);

    const closeModal = () => {
      emit("close");
    };

    const changeStringToArray = (arr) => {
      return arr?.split(",");
    };
    const imageSize = {
      SizeGuildGirl: "size_guide_girl.jpg",
      SizeGuildBoy: "size_guide_boy.jpg",
      SizeGuildFemale: "size_guide_female.jpg",
      SizeGuildMale: "size_guide_male.jpg",
      SizeGuildBaby: "size_guide_baby.jpg",
      SizeGuildUnisexKid: "size_guide_unisex_kid.jpg",
      SizeGuildUnisexAdult: "size_guide_unisex_adult.jpg",
      SizeGuildGenZ: "size.png",
      SizeGuild: "size-guild.png",
    };

    const imageSizeGuild = (sizeguide) => {
      switch (sizeguide) {
        case 193:
          return imageSize.SizeGuildGirl;
        case 194:
          return imageSize.SizeGuildBoy;
        case 195:
          return imageSize.SizeGuildFemale;
        case 196:
          return imageSize.SizeGuildMale;
        case 5534:
        case 5540:
          return imageSize.SizeGuildBaby;
        case 8163:
          return imageSize.SizeGuildUnisexKid;
        case 8164:
          return imageSize.SizeGuildUnisexAdult;
        case 9662:
          return imageSize.SizeGuildGenZ;
        default:
          return imageSize.SizeGuild;
      }
    };

    const urlImageSizeGuide = `/assets/${imageSizeGuild(props.id)}`;

    const activeIndex = ref(0);
    const setActive = (index) => {
      activeIndex.value = index;
    };

    return {
      closeModal,
      dataSize,
      dataHeader,
      dataBody,
      changeStringToArray,
      changeImage,
      urlImageSizeGuide,
      activeIndex,
      setActive,
    };
  },
});
